import { useState, useEffect } from "react";
import "./user-creation.css";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import Button from "../../../../ui/atoms/buttons/Button";
import InputText from "../../../../ui/atoms/inputs/input-text/InputText";
import InputSelect from "../../../../ui/atoms/inputs/input-select/InputSelect";
import PhoneInputWithFlag from "../../../../ui/organisms/phone-input/PhoneInputWithFlag";
//
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { MdPhotoCamera } from "react-icons/md";
import { PiFile, PiFiles } from "react-icons/pi";
import { BsEyeFill } from "react-icons/bs";
import { SlClose } from "react-icons/sl";
//
import {
  onHandleSingleFile,
  onHandleMultipleFiles,
  formatFileSize,
} from "../../../../core/utils/common-validators";
import { UserRegisterSchema } from "../../../../core/utils/validators/authentication";
import { isEmpty, wait } from "../../../../core/utils/helpers";
import { onCreateTeamMember } from "../../services/user";
import useAxiosPrivate from "../../../../app/providers/context-provider/useAxiosPrivate";
//
import countries from "../../../../app/config/countries.json";
import Swal from "sweetalert2";
import moment from "moment";

// Calculate min and max dates
const minDate = moment("1960-01-01").format("YYYY-MM-DD");
const maxDate = moment().subtract(17, "years").format("YYYY-MM-DD");

const UserUpdate = () => {
  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();
  const [isSending, setIsSending] = useState(false);

  const [thumbnailFile, setThumbnailFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [documents, setDocuments] = useState([]);
  const [previewDocument, setPreviewDocument] = useState(null);

  const currenTeamMember = useSelector(
    (state) => state.setInitConf.currentTeamMember
  );

  useEffect(() => {
    return () => {
      if (previewUrl) {
        URL.revokeObjectURL(previewUrl);
      }
    };
  }, [previewUrl]);

  useEffect(() => {}, [thumbnailFile]);

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    mode: "onTouched",
    resolver: yupResolver(UserRegisterSchema),
    defaultValues: {
      firstname: currenTeamMember?.firstname,
      lastname: currenTeamMember?.lastname,
      gender: currenTeamMember?.gender,
      mail: currenTeamMember?.mail,
      date_of_birth: moment(currenTeamMember?.date_of_birth).format("YYYY-MM-DD"),
      location_of_birth: currenTeamMember?.location_of_birth,
      origin_country: currenTeamMember?.origin_country,
      telephone: currenTeamMember?.telephone,
    },
  });

  const onSubmit = async (data) => {
    setIsSending(true);
    Swal.fire({
      title: "Updating team member...",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });
    await wait(700);
    //
    let formData = new FormData();
    //
    formData.append("firstname", data?.firstname);
    formData.append("lastname", data?.lastname);
    formData.append("gender", data?.gender);
    formData.append("telephone", phoneNumber);
    formData.append("mail", data?.mail);
    formData.append("date_of_birth", data?.date_of_birth);
    formData.append("location_of_birth", data?.location_of_birth);
    formData.append("origin_country", data?.origin_country);

    if (thumbnailFile) {
      formData.append("thumbnail", thumbnailFile);
    }

    if (documents && documents.length > 0) {
      documents.forEach((doc) => {
        formData.append("thumbnails", doc);
      });
    }

    //
    onCreateTeamMember(axiosPrivate, formData)
      .then((response) => {
        const _data = response?.data;
        Swal.close();
        setIsSending(false);

        if (_data?.status) {
          Swal.fire({
            title: "Team Member Creation",
            text: _data?.message,
            icon: "success",
            confirmButtonText: "OK",
            didOpen: () => {
              const btn = Swal.getConfirmButton(); //
              btn.style.backgroundColor = "#2840a8";
              btn.style.color = "white";
            },
          });
          reset();
          setThumbnailFile(null);
          setPreviewUrl(null);
          setDocuments([]);
        } else {
          Swal.fire({
            title: "Team Member Creation",
            text: _data?.message,
            icon: "info",
          });
        }
      })
      .catch((error) => {
        setIsSending(false);
        Swal.close();
        if (!error?.response) {
          Swal.fire({
            title: "Team Member Creation",
            text: "No server response",
            icon: "warning",
          });
        } else {
          Swal.fire({
            title: "Team Member Creation",
            text: error?.response?.data?.detail?.message,
            icon: "error",
          });
        }
      });
  };

  const removeFile = (indexToRemove) => {
    setDocuments((prevFiles) =>
      prevFiles.filter((_, idx) => idx !== indexToRemove)
    );
  };

  const onPreviewDocument = (file) => {
    const fileURL = URL.createObjectURL(file);

    if (file.type === "application/pdf") {
      // show PDF inline
      setPreviewDocument(fileURL);
    } else if (
      file.type === "application/msword" ||
      file.type ===
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
    ) {
      // DOC or DOCX: open in a new tab
      window.open(fileURL, "_blank");
    } else {
      alert("Preview not supported for this file type.");
    }
  };

  return (
    <form className="user-creation" onSubmit={handleSubmit(onSubmit)}>
      <div className="us-cr-head">
        <button type="button" onClick={() => navigate(-1)}>
          ⬅️ Back to list
        </button>
        <div className="w-full d-flex justify-space-between align-center">
          <h1>🔄 Updating Team member</h1>
          {isSending ? (
            <Button
              type={"button"}
              preferedStyle={"default"}
              title={"Creating new member..."}
            />
          ) : (
            <Button
              type={"submit"}
              preferedStyle={"normal"}
              title={"Validate and Update Informations"}
            />
          )}
        </div>
      </div>
      <div className="us-cr-body">
        <div
          className={
            !isEmpty(previewDocument) ? "information-section" : "w-90 m-auto"
          }
        >
          <h2>Personal Informations</h2>
          <div className="us-cr-fileds">
            <div className="thumbnails">
              <img
                src={previewUrl || process.env.PUBLIC_URL + "/user.png"}
                alt="new team member preview"
              />
              <div className="browse-image">
                <input
                  type="file"
                  id="input_file"
                  onChange={(e) => {
                    const _thumbFile = onHandleSingleFile(e);
                    setThumbnailFile(_thumbFile);
                    //   Create a temporary URL for the selected fil
                    const newPreviewUrl = URL.createObjectURL(_thumbFile);
                    setPreviewUrl(newPreviewUrl);
                  }}
                  accept="image/*"
                />
                <label htmlFor="input_file">
                  <MdPhotoCamera className="icon" />
                </label>
              </div>
              {thumbnailFile && (
                <span
                  className="span-remove"
                  onClick={() => {
                    setThumbnailFile(null);
                    setPreviewUrl(null);
                  }}
                >
                  <SlClose className="icon" />
                </span>
              )}
            </div>
            <div className="w-full d-flex gap-md">
              <div className="w-50">
                <InputText
                  type={"text"}
                  name={"firstname"}
                  title={"Firstname"}
                  error={errors?.firstname?.message}
                  register={register}
                />
              </div>
              <div className="w-50">
                <InputText
                  type={"text"}
                  name={"lastname"}
                  title={"Lastname"}
                  error={errors?.lastname?.message}
                  register={register}
                />
              </div>
            </div>
            <div className="w-full d-flex gap-md">
              <div className="w-50">
                <InputSelect
                  name={"gender"}
                  error={errors?.gender?.message}
                  register={register}
                  data={[
                    { key: "female", title: "Woman", is_activated: false },
                    { key: "male", title: "Man", is_activated: false },
                  ]}
                  placeholder={"Select gender"}
                />
              </div>
              <div className="w-50">
                <InputText
                  type={"text"}
                  name={"mail"}
                  title={"E-mail"}
                  error={errors?.mail?.message}
                  register={register}
                />
              </div>
            </div>
            <div className="w-full d-flex gap-md">
              <div className="w-50">
                <InputText
                  type={"date"}
                  name={"date_of_birth"}
                  title={"Date of birth"}
                  error={errors?.date_of_birth?.message}
                  register={register}
                  min={minDate}
                  max={maxDate}
                />
              </div>
              <div className="w-50">
                <InputSelect
                  name={"location_of_birth"}
                  error={errors?.location_of_birth?.message}
                  register={register}
                  data={[
                    ...countries.map((item) => ({
                      key: item.name.official, // value de l'option
                      title: `${item.flag} (${item.name.official})`, // texte affiché
                      is_activated: false, // tu peux mettre true si tu veux un défaut
                    })),
                  ]}
                  placeholder={"Location of birth"}
                />
              </div>
            </div>
            <div className="w-full d-flex gap-md">
              <div className="w-50">
                <InputSelect
                  name={"origin_country"}
                  error={errors?.origin_country?.message}
                  register={register}
                  data={[
                    ...countries.map((item) => ({
                      key: item.name.official, // value de l'option
                      title: `${item.flag} (${item.name.official})`, // texte affiché
                      is_activated: false, // tu peux mettre true si tu veux un défaut
                    })),
                  ]}
                  placeholder={"Country of Origin"}
                />
              </div>
              <div className="w-50">
                <PhoneInputWithFlag
                  value={phoneNumber}
                  onChange={setPhoneNumber}
                />
              </div>
            </div>
          </div>
          <h2>Personal Documents</h2>
          <div className="us-cr-assets">
            <div className="browse-image">
              <input
                type="file"
                id="input_files"
                onChange={(e) => {
                  const _documentFiles = onHandleMultipleFiles(e);
                  setDocuments([..._documentFiles]);
                }}
                multiple
                accept=".pdf,.doc,.docx"
              />
              <label htmlFor="input_files">
                <PiFiles className="icon" />
                <span>Load Documents</span>
              </label>
            </div>
            {documents.length > 0 && (
              <div className="files-container">
                {documents.map((document, idx) => {
                  return (
                    <div className="file-item" key={idx}>
                      <span className="icon-wrapper">
                        <PiFile className="icon" />
                      </span>
                      <div className="file-description">
                        <h1>{document?.name}</h1>
                        <span>{formatFileSize(document?.size)}</span>
                      </div>
                      <div className="file-actions">
                        <span onClick={() => onPreviewDocument(document)}>
                          <BsEyeFill className="icon" />
                        </span>
                        <span onClick={() => removeFile(idx)}>
                          <SlClose className="icon" />
                        </span>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        </div>
        {/* PDF preview section */}
        {previewDocument && (
          <div className="preview-section">
            <iframe
              src={previewDocument}
              width="100%"
              height="100%"
              title="PDF Preview"
              style={{ border: "1px solid #ccc" }}
            ></iframe>
          </div>
        )}
      </div>
    </form>
  );
};

export default UserUpdate;
